import React from 'react';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import CheckboxField from '../../../../common/formComponents/CheckboxField/CheckboxField';
import { fieldNames } from '../constants';

const WithLunchBreakRow = ({ form }) => {
  return (
    <FormRow>
      <CheckboxField
        name={fieldNames.withLunchBreak}
        form={form}
        options={{ initialValue: false }}
        text="Обеденный перерыв"
      />
    </FormRow>
  );
};

export default WithLunchBreakRow;
